const LOG_PREFIX = "[OCM][PageSense] "
let pageSense = async (utils) => {
  return new Promise((resolve, reject) => {
    let pageType = 'ROS';
    
    if (window.location.href.indexOf('mikropragmata') > -1) {
      utils.loadStyle('.das_top:empty, .das_head:empty {display:block !important}');
    }

    let sub_paths = window.location.pathname.replace("/", "").split("/") || [];
    let custom_paths = [];
    sub_paths = sub_paths.filter(String);

    if (window.hasOwnProperty('pageArticle') && window.pageArticle) {
      pageType = 'Article' //https://ocmdm.zendesk.com/agent/tickets/13536
    }

//     if (utils.is_mobile && pageType !== 'noads') {
//       utils.loadScript('//gr.ads.justpremium.com/adserve/js.php?zone=127404','text/javascript');
//     }
    
    fou(utils)

    resolve(pageType)
  });
};

let fou = (utils) => {
  let fous = document.createElement('script')
  fous.src = 'https://eu.b2c.com/api/init-224mtm6aorewjg83k2h.js'
  fous.async = 'true'
  fous.setAttribute('data-cfasync', 'true')
  utils.doc_head.append(fous)
}

module.exports = pageSense;